export class HalkbankPaymentModel {
    public "clientid": any;
    public "storetype": any = "3d_pay_hosting";
    public "hash": any;
    public "trantype": any = "Auth";
    public "amount": any;
    public "currency": any = "807";
    public "oid": any;
    public "okUrl": any;
    public "failUrl": any;
    public "lang": any = "en";
    public "rnd": any;
    public "encoding": any = "UTF-8";
    public "refreshtime": any = "15"
    public "instalmentCount": any;
}
// = clientid + oid + amount + okurl + failurl + trantype + instalment + rnd + storekey ;